module.exports = __webpack_public_path__ + "static/newconstruction-b49e699dae3e3e31699679f46a47e81d.jpg";